export default "/images/vendor/flag-icon-css/flags/4x3/fm.svg?3bfd96ee5faa59b8017a192bff06f6d6";